import store from '../store'

export default function useBusinessProfileService() {
  const handleGetBusinessProfile = async (request = {}) => {
    const { data: result } = await store.dispatch(
      'ssoAccount/getProfile',
      request
    )
    return result.result
  }

  const handleGetProfileMembers = async ({
    pageNumber,
    pageSize,
    profileId
  }) => {
    const response = await store.dispatch('ssoAccount/getProfileMembers', {
      page_number: pageNumber - 1,
      page_size: pageSize,
      business_id: profileId
    })

    if (response && response.status === 200) {
      const { channel_member, total_channel_member } = response.data.result

      const rows = channel_member.map((item) => ({
        id: item.id,
        email: item.member_login_data.email,
        name: `${item.member_account.first_name || ''} ${item.member_account.last_name || ''}`,
        role: item.channel_member_role.name,
        roleId: item.channel_member_role.id.toString(),
        status: item.email_validation_status.status_description,
        sso_channel_member_id: item.channel_member_id,
        invitation_expired_at: item.invitation_expired_at
      }))

      return {
        rows,
        pageCount: Math.ceil(total_channel_member / pageSize)
      }
    }

    return {
      rows: [],
      pageCount: 1
    }
  }

  return {
    handleGetBusinessProfile,
    handleGetProfileMembers
  }
}
